export default {
	section_banner: {
		title: {
			one: 'あなたについて',
		},
		main_title: {
			one: '仕事',
		},
		paragraph: {
			one: 'セキュリティと管理は当社が担当します。お客様は運用だけに集中していただけます。',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},

	wallet_sec: {
		label: '手間のかからない方法',
		title: {
			one: '店舗経営は',
			two: 'また',
			three: '自動',
		},
		paragraph: {
			one: '毎日手動で管理していませんか？JPWorldPayを使えば、すべてが自動で処理されます。スマートな取引からリアルタイムの追跡まで、JPWorldPayは日々の財務業務を簡素化し、最も重要なことに集中できるようにします。',
			two: 'JPWorldPayなら、自動化と効率性が融合します。反復的な作業や手作業によるミスとはおさらば。当社のプラットフォームはワークフローを効率化し、記録を整理し、財務状況を常に把握できるようにします。',
		},
		cta_buttons: {
			one: '始めましょう',
		},
	},

	corps_dwn: {
		label: '簡単＆スムーズなプロセス',
		title: {
			one: 'サインアップしてストアを完了する',
			two: '登録',
		},
		paragraph:
			'フランチャイズ管理プログラムを無料でご利用いただけます。生涯アクセスと利用料はかかりません。JPWorldPayは、フランチャイズ事業を効率的に管理するための強力なツールを完全無料でご提供します。売上追跡からデータ整理まで、すべて無料でご利用いただけます。追加料金は一切かかりません。',
		cta_buttons: {
			one: 'ストアの作成',
		},
	},

	section_newsletter: {
		label: 'ニュースレターを購読する',
		title: {
			one: '購読する',
			two: '最新情報を入手',
		},
		description: {
			one: '購読して、オファーや最新情報をメールボックスに直接受け取りましょう。',
			two: '当社の JPWorldPay ソリューションが貴社のビジネスをどのように拡大できるかについて詳しくは、お問い合わせください。',
		},
		form: {
			placeholder: 'メールID',
			button: '今すぐ購読する',
		},
	},
};
